export default "__VITE_ASSET__CEsBN7Vm__"